import { parseUiConfig } from "adl-service/ui-config";

/**
 * Bootstrap gate. The app's UI config is injected by `/_a/uiconfig.esm.js`,
 * which is served by the app server. If that server is down (e.g. a failed
 * migration on startup) the config never loads and every module that reads it
 * at import time throws "UI_CONFIG not populated", crashing the app before any
 * error boundary mounts.
 *
 * So we check the config here, before importing the app graph. When it is
 * missing we render a self-contained connection fallback instead, and only
 * import the real app once we know it can start.
 */
async function bootstrap() {
  try {
    parseUiConfig();
  } catch {
    const { renderConnectionFallback } = await import(
      "components/connection/connection-fallback"
    );
    renderConnectionFallback();
    return;
  }

  await import("./bootstrap-app");
}

void bootstrap();
